<template>
    <div>
        <dashboard-component/>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    }
}
</script>

<style scoped>
</style>